import { render, staticRenderFns } from "./menber_detail.vue?vue&type=template&id=0363e7c8&scoped=true"
import script from "./menber_detail.vue?vue&type=script&lang=js"
export * from "./menber_detail.vue?vue&type=script&lang=js"
import style0 from "./menber_detail.vue?vue&type=style&index=0&id=0363e7c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0363e7c8",
  null
  
)

export default component.exports